import { SensorDetails } from '../../../../serverApi';

const isSensorLocked = (sensor: SensorDetails) => {
  return Boolean(sensor.zone && sensor.zone.api_lock);
};

export default isSensorLocked;
